// src/components/ModuleDisabled.jsx
import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function ModuleDisabled({ moduleLabel = 'Module', canManage = false }) {
  const navigate = useNavigate()

  return (
    <div className="p-6">
      <div className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-amber-900">
        <div className="font-semibold">{moduleLabel} désactivé</div>
        <div className="text-sm mt-1">
          Ce module n'est pas activé pour votre tenant.
        </div>
        {canManage && (
          <button
            type="button"
            onClick={() => navigate('/settings?tab=modules')}
            className="mt-3 rounded-lg border border-amber-300 bg-white px-3 py-2 text-xs hover:bg-amber-100"
          >
            Activer depuis Paramètres
          </button>
        )}
      </div>
    </div>
  )
}
